import { Feature, Geometry } from '@turf/helpers';

import Site, { ISiteAPI } from '@/common/models/site/Site';
import Validatable from '@/validator/Validatable';

interface ISiteMarketAPI {
  site: ISiteAPI;
}

export interface IMarketAPI {
  market_id: number;
  name: string;
  external_id: string;
  type: string;
  location_id: number;
  geometry?: Geometry;
  site_markets?: ISiteMarketAPI[];
}

export default class Market extends Validatable<Market> {
  id: number;

  name: string;

  externalID: string;

  type: string;

  locationID: number;

  geometry?: Geometry;

  sites: Site[];

  constructor(
    id = -1,
    name: string,
    externalID: string,
    type: string,
    locationID: number,
    geometry?: Geometry,
    sites: Site[] = [],
  ) {
    super();
    this.id = id;
    this.name = name;
    this.externalID = externalID;
    this.type = type;
    this.locationID = locationID;
    this.geometry = geometry;
    this.sites = sites;
  }

  get displayName(): string {
    return `${this.name} (${this.type})`;
  }

  get feature(): Feature {
    return {
      type: 'Feature',
      geometry: this.geometry,
      properties: {
        id: this.id,
      },
    };
  }

  static fromApi(apiObject: IMarketAPI): Market {
    return new Market(
      apiObject.market_id,
      apiObject.name,
      apiObject.external_id,
      apiObject.type,
      apiObject.location_id,
      apiObject.geometry ? apiObject.geometry : null,
      apiObject.site_markets
        ? apiObject.site_markets
            .map((sm) => sm.site)
            .filter((x) => !!x)
            .map((s) => Site.fromApi(s))
        : [],
    );
  }

  toApi(): IMarketAPI {
    return {
      market_id: this.id,
      name: this.name,
      external_id: this.externalID,
      type: this.type,
      location_id: this.locationID,
      geometry: this.geometry,
    };
  }
}
